import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'product',
    'positioning',
    'positioningChild',
    'typology',
  ]

  adjustHeights() {
    const typologies = this.typologyTargets;
    const products = this.productTargets;

    typologies.forEach((typology, index) => {
      const positioningsQuantity = typology.dataset.productsPositioningQuantity;
      const positioningHeight = this.positioningChildTargets[0].getBoundingClientRect().height;

      let typologyHeight = positioningHeight;
      if(positioningsQuantity > 0) {
        typologyHeight = positioningHeight * positioningsQuantity;
      }
      typology.style.height = `${typologyHeight}px`;

      const associatedProduct = products[index];
      if (associatedProduct) {
        associatedProduct.style.height = `${typologyHeight}px`;
      }
    });
  }
}
